import {
  ROUTE_EDC_MASTER_CONTACT_LIST,
  ROUTE_INDIVIDUAL_CAMPAIGN,
  ROUTE_DEAL_SCREENER_EDC
} from "constants/routes";
import { matchPath } from "react-router-dom";

const listOfRoutesWithoutNavbar = [
  ROUTE_EDC_MASTER_CONTACT_LIST,
  ROUTE_INDIVIDUAL_CAMPAIGN,
  ROUTE_DEAL_SCREENER_EDC()
];

export const navBarShouldBeVisible = pathname => !listOfRoutesWithoutNavbar.some(routeWithoutNavbar => matchPath(pathname, { path: routeWithoutNavbar }));
